// extracted by mini-css-extract-plugin
export default {"melodyVideo":"yM-z","isFullWidth":"zM-z","landingPageVideo":"AM-z","play":"BM-z","iframeVideo":"CM-z","playHidden":"DM-z","fullwidth":"EM-z"};